import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const setShippingMethodOrder = {
  name: "setShippingMethodOrder" as const,
  input: z.object({
    checkoutExperienceId: zExt.objectId(),
    orderedShippingMethodIds: z.array(zExt.objectId()),
  }),
  output: z.null(),
};
